import { render, staticRenderFns } from "./NotLoggedIn.vue?vue&type=template&id=956aa6bc&scoped=true"
import script from "./NotLoggedIn.vue?vue&type=script&lang=js"
export * from "./NotLoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956aa6bc",
  null
  
)

export default component.exports